import { oneFromSnapshot } from "@buildwithflux/firestore-compatibility-layer";
import { AutoLayoutJobMetadata, jobMetadataUidFromJobUid, } from "@buildwithflux/models";
import { guid, silentLogger } from "@buildwithflux/shared";
import { SubscriptionManager } from "../subscriptions";
export class FirestoreAutoLayoutJobMetadataRepository {
    db;
    logger;
    subscriptionMgr = new SubscriptionManager();
    firestoreSubscriptions = new Map();
    constructor(db, logger = silentLogger) {
        this.db = db;
        this.logger = logger;
    }
    async get(userHandle, jobUid) {
        const raw = oneFromSnapshot(await this.db.userJobsCollection(userHandle).doc(jobMetadataUidFromJobUid(jobUid)).get(), () => undefined);
        if (!raw)
            return undefined;
        const metadataResult = AutoLayoutJobMetadata.safeParse(raw);
        if (!metadataResult.success) {
            this.logger.error(`AutoLayoutJobMetadata validation failed in get job metadata ${jobUid}`, {
                rawData: JSON.stringify(raw),
                validationErrors: metadataResult.error.issues,
            });
            throw metadataResult.error;
        }
        return metadataResult.data;
    }
    save(userHandle, jobMetadata) {
        return (this.db
            .userJobsCollection(userHandle)
            .doc(jobMetadata.uid)
            // TODO: Fix as cast here - think the better way to do this is to store user jobs separately in different sub-collection
            // {merge: true} enables partial updates: only fields present in jobMetadata are written,
            // preserving existing fields (e.g. recordResolvedVersion writes only resolvedApiVersion
            // without overwriting iterations, errors, etc.)
            .set(jobMetadata, { merge: true })
            .then());
    }
    async saveError(userHandle, jobUid, errorMessage) {
        const jobMetadata = await this.get(userHandle, jobUid);
        if (!jobMetadata) {
            this.logger.warn(`Job meta ${jobUid} does not exist in Firestore!`);
            return;
        }
        jobMetadata.errors ??= [];
        jobMetadata.errors.push({
            message: errorMessage,
            timestamp: Date.now(),
            uid: guid(),
        });
        await this.save(userHandle, jobMetadata);
    }
    subscribe(userHandle, jobUid, onChange) {
        const jobMetadataUid = jobMetadataUidFromJobUid(jobUid);
        const jobMetadataRef = this.db.userJobsCollection(userHandle).doc(jobMetadataUid);
        const unsubscribe = this.subscriptionMgr.addSubscription(jobMetadataUid, onChange, () => {
            const existingSubCount = this.subscriptionMgr.listenerCount(jobMetadataUid);
            if (existingSubCount === 0) {
                const firestoreUnsub = this.firestoreSubscriptions.get(jobMetadataUid);
                if (firestoreUnsub) {
                    firestoreUnsub();
                    this.firestoreSubscriptions.delete(jobMetadataUid);
                }
            }
        });
        const existing = this.firestoreSubscriptions.get(jobMetadataUid);
        if (!existing) {
            let isInitial = true;
            const firestoreUnsub = jobMetadataRef.onSnapshot((snapshot) => {
                const data = snapshot.data();
                if (!data) {
                    this.logger.warn(`Job meta ${jobMetadataUid} does not exist in Firestore!`);
                    return;
                }
                this.notifyJobChangeListeners(jobMetadataUid, {
                    type: "updated",
                    // TODO: Fix as any cast here - think the better way to do this is to store user jobs separately in different sub-collection
                    data: data,
                    isInitial,
                });
                isInitial = false;
            });
            this.firestoreSubscriptions.set(jobMetadataUid, firestoreUnsub);
        }
        return unsubscribe;
    }
    notifyJobChangeListeners(jobUid, change) {
        this.subscriptionMgr.notify(jobUid, change);
    }
}
//# sourceMappingURL=FirestoreAutoLayoutJobMetadataRepository.js.map